import { useEffect, useState } from "react";
import { getUserId, getUserRole } from "../utils/Auth"; // 🔥 Importáljuk a felhasználó azonosításához szükséges függvényeket
import API_BASE_URL from "../config";

const useAdminData = () => {
  const [userName, setUserName] = useState(""); // 🔥 Mostmár minden bejelentkezett felhasználó neve itt lesz tárolva
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [myCustomers, setMyCustomers] = useState([]);
  const [users, setUsers] = useState([]);
  const userId = getUserId();
  const userRole = getUserRole(); // 🔥 Megnézzük, hogy admin vagy agent
  const [hasCommission, setHasCommission] = useState(false); // 🔥 Új state

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await fetch(`${API_BASE_URL}/api/users/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const userData = await response.json();
        setUserName(userData.name); // 🔥 Mostmár akár admin, akár agent, itt tároljuk a nevet
        setHasCommission(userData.hasCommission); // 🔥 Mentjük az értéket
      } catch (err) {
        setError(err.message);
      }
    };

    fetchUserDetails();
  }, [userId]);

  const fetchCustomers = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(`${API_BASE_URL}/api/customers/all`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) {
        throw new Error("Hiba az ügyfelek betöltésekor.");
      }

      const data = await response.json();
      setCustomers(data);
      setUsers([]);
      setMyCustomers([]);
    } catch (err) {
      console.error("Error fetching customers:", err.message); // 🔥 Error logging
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchMyCustomers = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");

      const apiUrl =
        userRole === "Agent"
          ? `${API_BASE_URL}/api/customers`
          : `${API_BASE_URL}/api/customers/mine`;

      const response = await fetch(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) {
        throw new Error("Hiba a saját ügyfelek betöltésekor.");
      }

      const data = await response.json();
      setMyCustomers(data);
      setCustomers([]);
      setUsers([]);
    } catch (err) {
      console.error("Error fetching my customers:", err.message); // 🔥 Error logging
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchUsers = async () => {
    if (userRole !== "Admin") {
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(`${API_BASE_URL}/api/users`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) {
        throw new Error("Hiba a felhasználók betöltésekor.");
      }

      const data = await response.json();
      setUsers(data);
      setCustomers([]);
      setMyCustomers([]);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    userName, // 🔥 Mostmár itt a felhasználó neve
    hasCommission,
    loading,
    error,
    customers,
    myCustomers,
    users,
    fetchCustomers,
    fetchMyCustomers,
    fetchUsers,
  };
};

export default useAdminData;
